import uaParserJs from 'ua-parser-js'
const uaParser = uaParserJs()
const { browser } = uaParser
let newChrome = browser && browser.name && browser.name === 'Chrome' && browser.version && browser.version.slice(0, 3) && Number(browser.version.slice(0, 3)) >= 123
// bloom-test中文的
export const bloomTestZh = {
  bloomTest00001: '拼命加载题目中',
  bloomTest00002: '上一题',
  bloomTest00003: '交 卷',
  bloomTest00004: '下一题',
  bloomTest00005: '剩余时间',
  bloomTest00006: '已用时间',
  bloomTest00007: '当前进度',
  bloomTest00008: '答题卡',
  bloomTest00009: '已答',
  bloomTest00010: '未答',
  bloomTest00011: '交卷',
  bloomTest00012: '请勿离开页面，考试倒计时结束后系统自动交卷。',
  bloomTest00013: '交卷成功',
  bloomTest00014: '关闭',
  bloomTest00015: '进入下一科考试',
  bloomTest00016: '距离考试结束还有',
  bloomTest00017: '分钟，不可以提前交卷。',
  bloomTest00018: '确定',
  bloomTest00019: '交卷成功',
  bloomTest00020: '距离考试结束还有5分钟',
  bloomTest00021: '距离考试结束还有3分钟',
  bloomTest00022: '单选题',
  bloomTest00023: '多选题',
  bloomTest00024: '还未开始哦',
  bloomTest00025: '开始时间',
  bloomTest00026: '知道了',
  bloomTest00027: '年',
  bloomTest00028: '月',
  bloomTest00029: '日',
  bloomTest00030: '考试开始倒计时',
  bloomTest00031: '为避免断开连接，倒计时期间请勿使用或调整监考设备',
  bloomTest00032: '你来晚咯，',
  bloomTest00033: '已结束！',
  bloomTest00034: '进入测评',
  bloomTest00035: '很遗憾，',
  bloomTest00036: '考试已开始，你已经无法参加！',
  bloomTest00037: '缴费',
  bloomTest00038: '小时后方可开始考试哦！',
  bloomTest00039: '恭喜你，已完成此科考试！',
  bloomTest00040: '恭喜你，已完成所有考试！',
  bloomTest00041: '点击进入下一科考试',
  bloomTest00042: '总分',
  bloomTest00043: '时长',
  bloomTest00044: '题目数量',
  bloomTest00045: '测评说明 ',
  bloomTest00046: '限时 ',
  bloomTest00047: '不限时 ',
  bloomTest00048: '分钟 ',
  bloomTest00049: '开始答题 ',
  bloomTest00050: '个',
  bloomTest00051: '分',
  bloomTest00052: '考试时间到！系统自动交卷中…',
  bloomTest00053: '继续作答',
  bloomTest00054: '再检查下',
  bloomTest00055: '距离考试结束还有',
  bloomTest00056: '分钟，是否确定交卷？',
  bloomTest00057: '确定交卷吗？',
  bloomTest00058: '您还有',
  bloomTest00059: '个题目未作答',
  bloomTest00060: '实时画面',
  bloomTest00061: '您已被管理员强制交卷',
  bloomTest00062: '切屏次数达到上限，系统已强制交卷！',
  bloomTest00063: '您还有',
  bloomTest00064: '分钟，请耐心检查',
  bloomTest00065: '不可交卷',
  bloomTest00066: '考试开始',
  bloomTest00067: '分钟后才可交卷，当前用时',
  bloomTest00068: '，请继续答题!',
  bloomTest00069: '你已离开考试',
  bloomTest00070: '次',
  bloomTest00071: '达到上限后组委会将进行重点关注，请立即重新进入！考试过程中请勿随意退出全屏或点击非答题区域。',
  // bloomTest00071: '当离开',
  // bloomTest00072: '次时，系统将强制交卷',
  bloomTest00073: '确定离开当前页面吗？',
  bloomTest00074: '你即将进入全屏考试',
  bloomTest000741: '当前考试已开启切屏限制，请在考试开始前进入全屏状态。考试过程中请勿随意退出全屏或点击非答题区域。',
  bloomTest00075: '当前考试已开启切屏限制，请勿随意切屏',
  bloomTest00076: '当前考试已开启视频监控，请打开摄像设备',
  bloomTest00077: '进入全屏考试',
  bloomTest00078: '退出全屏将判定切屏一次，请勿退出全屏',
  bloomTest00079: '视频连接中断，即将刷新页面',
  bloomTest00080: '未检测到摄像头，请更换带有摄像头的设备。',
  bloomTest00081: '视频获取失败，请刷新页面',
  bloomTest00082: '摄像头未开启，即将离开本页面，请开启摄像头重新进入！',
  bloomTest00083: '需开启摄像头才可进入考试。(如已开启，请刷新页面)',
  bloomTest000831: '需开启摄像头才可进行身份核验。(如已开启，请刷新页面)',
  bloomTest000832: '并刷新页面',
  bloomTest00084: '标题',
  bloomTest00085: '请输入内容',
  bloomTest00086: '当前字数',
  bloomTest00087: '查看全部',
  bloomTest00089: '收起',
  bloomTest00090: '提交',
  bloomTest00091: '您已离开写作',
  bloomTest00092: '次',
  bloomTest00093: '当离开',
  bloomTest00094: '次时，系统将强制提交',
  bloomTest00095: '确定要提交么？',
  bloomTest00096: '提交后不可以修改',
  bloomTest00097: '取消',
  bloomTest00098: '你即将进入全屏写作',
  bloomTest00099: '当前写作已开启切屏限制，请勿随意切屏',
  bloomTest00100: '当前写作已开启视频监控，请打开摄像设备',
  bloomTest00101: '进入全屏写作',
  bloomTest00102: '请填写标题后提交',
  bloomTest00103: '请填写内容后提交',
  bloomTest00104: '提交成功！',
  bloomTest00105: '请使用正常流程进入写作文！',
  bloomTest00106: '考试时间到，交卷成功！',
  bloomTest00107: '请重新开启摄像头',
  bloomTest00108: '保存',
  bloomTest00109: '自动保存成功  上次保存时间：',
  bloomTest00110: '自动保存成功',
  bloomTest00111: '编辑',
  bloomTest00112: '问答题',
  bloomTest00113: '您不在本场考试名单内，无法参加考试！',
  bloomTest00114: '抱歉！因特殊原因，考试已终止！',
  bloomTest00115: '提 醒',
  bloomTest00116: '我知道了',
  bloomTest00117: '网络连接超时，请刷新页面并等候一分钟',
  bloomTest00118: '摄像头被其他应用占用，请关闭其他占用摄像头的网页或应用',
  bloomTest00119: '请打开对bloom网页的摄像头授权',
  bloomTest00120: '无法找到您的摄像头，请确认已接入摄像头或摄像头驱动完好',
  bloomTest00121: '当前浏览器不支持考试的摄像头服务，请使用最新版谷歌浏览器',
  bloomTest00122: '网络连接异常，请检查网络',
  bloomTest00123: '当前浏览器不支持考试的摄像头服务，请使用最新版谷歌浏览器',
  bloomTest00124: '请重新打开麦克风！',
  bloomTest00125: '无法找到您的摄像头或麦克风，请确认已接入设备或设备驱动完好',
  bloomTest001251: '无法找到您的摄像头，请确认已接入摄像头或摄像头驱动完好',
  bloomTest001252: '无法找到您的麦克风，请确认已接入麦克风或麦克风驱动完好',
  bloomTest00126: '请重新开启摄像头或麦克风',
  bloomTest00127: '',
  bloomTest00128: '本场考试已开启电脑屏幕监考，开始答题前请共享',
  bloomTest00129: '整个屏幕',
  bloomTest00130: '共享屏幕，开始答题',
  bloomTest00131: '提示',
  bloomTest00132: '请选择共享整个屏幕。',
  bloomTest00133: '好的',
  bloomTest00134: '未监测到你的手机监考信号，请退出无关应用，返回监考界面或重新扫码连接。',
  bloomTest00135: '你已停止共享屏幕，请重新授权。',
  bloomTest00136: '正在启动你的摄像头，请3秒后重试。',
  bloomTest00137: '正在启动你的摄像头和麦克风，请3秒后重试。',
  bloomTest00138: '您的摄像头或麦克风设备无法正常工作，请尝试更换电脑设备。',
  bloomTest00139: '请输入',
  bloomTest00140: '请选择一个写作题目（共',
  bloomTest00141: '个',
  bloomTest00142: '）',
  bloomTest00143: '保存',
  bloomTest00144: '保存失败，请重试',
  bloomTest00145: '更换题目',
  bloomTest00146: '最新保存时间 : ',
  bloomTest00147: '字数：',
  bloomTest00148: '写作题',
  bloomTest00149: '本场考试已开启摄像头监考，请打开摄像头权限并刷新页面。',
  bloomTest00150: '本场考试已开启摄像头和麦克风监考，请打开摄像头和麦克风权限并刷新页面。',
  bloomTest00151: newChrome ? 'https://img.webloom.cn/img/testImgShui.jpg' : 'https://img.webloom.cn/img/SC.png',
  bloomTest00152: newChrome ? 'https://img.webloom.cn/img/testImgShui.jpg' : 'https://img.webloom.cn/img/SAMC.png',
  bloomTest00153: 'https://img.webloom.cn/img/MSC.png',
  bloomTest00154: 'https://img.webloom.cn/img/weixinScanZH1.png',
  bloomTest00155: '暂不支持平板，请打开手机微信或QQ扫码连接手机摄像头',
  bloomTest00156: '请确保可以拍摄到你的正面',
  bloomTest00157: '选择摄像头：',
  bloomTest00180: '查看',
  bloomTest00181: '你没有访问权限哦~',
  bloomTest00182: '提交成功',
  bloomTest00183: '提交失败',
  bloomTest00184: '已标记',
  bloomTest00185: '已取消标记',
  bloomTest00186: '已有',
  bloomTest00187: '位考生被发现有违规嫌疑，请遵守考试纪律',
  bloomTest00189: '本场考试已开启麦克风监考，请打开麦克风权限并刷新页面。',
  bloomTest00188: '考试已关闭',
  bloomTest00190: '网络异常，无法播放音频，请重试。',
  bloomTest00191: '浏览器不支持播放音频，请重试，若多次尝试依旧不成功，请更新浏览器。',
  bloomTest00192: '重新播放',
  bloomTest00193: 'exceptionDescCn',
  bloomTest00194: '网络连接超时，请刷新设备调试任务页面后重试',
  bloomTest00195: '刷新',
  bloomTest00196: '缺考',
  bloomTest00197: '已完成',
  bloomTest00198: '准备中',
  bloomTest00199: '未开始',
  bloomTest00200: '考试中',
  bloomTest00201: '限时',
  bloomTest00202: '已结束作答，即将进行答题的是',
  bloomTest00203: '已结束作答，现在进行答题的是',
  bloomTest00204: '考试时间结束后才可以交卷',
  bloomTest00205: '倒计时：',
  bloomTest00206: '标记',
  bloomTest00207: '当前科目考试已结束。请休息五分钟，在此期间请勿使用任何其他电子设备。休息过后，将进行两分钟的环境检查。请在检查开始前及时返回。',
  bloomTest00208: '倒计时结束后才可以进入答题。',
  bloomTest00209: '计算器',
  bloomTest00210: '溢出',
  bloomTest00211: '除以零',
  bloomTest00212: '错误',
  bloomTest00213: '你已完成所有候考流程，请等待考试开始',
  bloomTest00214: '考试未开始',
  bloomTest00215: 'AI批改',
  bloomTest00216: 'AI正在批改中…',
  bloomTest00217: 'AI批改结果',
  bloomTest00218: '请写满200字，让AI能更好地为你分析。',
  bloomTest00219: '内容由AI生成，仅供参考，不具备学术承诺',
  bloomTest00220: 'AI批改次数已达上限',
  bloomTest00221: 'AI批改遇到了卡点，请稍后重试',
  bloomTest00222: '写作中存在不规范用语，请更正后再进行AI批改。'
}
// bloom-test英文的
export const bloomTestEn = {
  bloomTest00001: 'Loading',
  bloomTest00002: 'Previous',
  bloomTest00003: 'Submit',
  bloomTest00004: 'Next',
  bloomTest00005: 'Time remaining',
  bloomTest00006: 'Elapsed time',
  bloomTest00007: 'Current progress',
  bloomTest00008: 'Answer Sheet',
  bloomTest00009: 'Answered',
  bloomTest00010: 'Unanswered',
  bloomTest00011: 'Submit',
  bloomTest00012: 'Please do not leave the page, the system will submit the papers automatically after the countdown.',
  bloomTest00013: 'Submitted successfully!',
  bloomTest00014: 'Close',
  bloomTest00015: 'Go to the next test',
  bloomTest00016: 'There are ',
  bloomTest00017: ' minutes left, please recheck your answers.',
  bloomTest00018: 'OK',
  bloomTest00019: 'Submitted successfully',
  bloomTest00020: 'Last 5 minutes for the exam',
  bloomTest00021: 'Last 3 minutes for the exam',
  bloomTest00022: 'Single Choice',
  bloomTest00023: 'Multiple Choice',
  bloomTest00024: ' not yet started',
  bloomTest00025: ' starting time',
  bloomTest00026: 'Got it',
  bloomTest00027: '-',
  bloomTest00028: '-',
  bloomTest00029: '-',
  bloomTest00030: 'Time remaining',
  bloomTest00031: 'To keep connection, do not use your invigilation device.',
  bloomTest00032: '',
  bloomTest00033: 'Tests are over. No participant is permitted to enter now.',
  bloomTest00034: 'Enter test',
  bloomTest00035: 'The test has begun,',
  bloomTest00036: 'no late participant is permitted to enter now.',
  bloomTest00037: 'The test can be started after paying ',
  bloomTest00038: ' hours.',
  bloomTest00039: 'Congratulations！This test has been completed！',
  bloomTest00040: 'Congratulations！You have completed the test！',
  bloomTest00041: 'Click and go to the next test',
  bloomTest00042: 'Total score',
  bloomTest00043: 'Time length',
  bloomTest00044: 'Number of questions',
  bloomTest00045: 'Test Instructions ',
  bloomTest00046: 'Time length ',
  bloomTest00047: 'Unlimited Time ',
  bloomTest00048: ' minutes ',
  bloomTest00049: 'Start the Test ',
  bloomTest00050: '',
  bloomTest00051: '',
  bloomTest00052: 'Time’s up! Test submitting...',
  bloomTest00053: 'Continue the test',
  bloomTest00054: 'Check again',
  bloomTest00055: 'Time remaining ',
  bloomTest00056: 'minutes, are you sure to submit the answer',
  bloomTest00057: 'Are you sure to submit the answer？',
  bloomTest00058: 'There are ',
  bloomTest00059: ' questions unanswered.',
  bloomTest00060: 'Real-time screen',
  bloomTest00061: 'Your answers have been submitted compulsorily by the administrator.',
  bloomTest00062: 'You have switched pages too many times, your answers have been submitted compulsorily!',
  bloomTest00063: 'You still have ',
  bloomTest00064: 'minutes left, please check your answers carefully.',
  bloomTest00065: 'Submission is not allowed',
  bloomTest00066: 'Your answers cannot be submitted until ',
  bloomTest00067: ' minutes after the exam begins. The current time is  ',
  bloomTest00068: ', please continue to answer questions.',
  bloomTest00069: 'Left ',
  bloomTest00070: ' time(s) already',
  bloomTest00071: `You'll draw attention to Committee when reaching the upper limit. Please re-enter NOW! Do not switch pages or click on the non-answer area at will during the test.`,
  // bloomTest00071: 'Your answers will be submitted compulsorily after you have exited the exam page ',
  // bloomTest00072: ' times.',
  bloomTest00073: 'Are you sure to exit the current page?',
  bloomTest00074: 'You are about to enter the full-screen test.',
  bloomTest000741: 'The current test has restrictions on page switching, please enter full screen before the test begins. Do not switch pages or click on the non-answer area at will during the test.',
  bloomTest00075: 'The current test has restrictions on page switching, please do not switch pages at will.',
  bloomTest00076: 'The current test has video monitoring, please turn on the camera.',
  bloomTest00077: 'Enter the full-screen test',
  bloomTest00078: 'Exiting the full screen will be regarded as switching pages once, so please do not exit the full screen.',
  bloomTest00079: 'Video connection broke down, this page will be refreshed soon.',
  bloomTest00080: 'No cameras detected, please use the device with camera.',
  bloomTest00081: 'Video acquisition failed, please refresh the page.',
  bloomTest00082: 'The camera has not been turned on, you will leave this page now, please turn on the camera and re-enter this page!',
  bloomTest00083: 'Turn on the camera to enter the exam.（If it is turned on, please refresh the page）',
  bloomTest000831: 'Turn on the camera to finish the identity verification .（If it is turned on, please refresh the page）',
  bloomTest000832: ' and refresh the page.',
  bloomTest00084: 'Title',
  bloomTest00085: 'Please enter',
  bloomTest00086: 'Words',
  bloomTest00087: 'View all',
  bloomTest00089: 'Close',
  bloomTest00090: 'Submit',
  bloomTest00091: 'You have exited the writing page ',
  bloomTest00092: ' times.',
  bloomTest00093: 'Your essay will be submitted compulsorily if you exit the page ',
  bloomTest00094: ' times.',
  bloomTest00095: 'Are you sure you want to submit your essay?',
  bloomTest00096: 'No modification is allowed after submission.',
  bloomTest00097: 'Cancel',
  bloomTest00098: 'You will enter the full-screen writing.',
  bloomTest00099: 'The page shifting monitoring is open. Please stay on the page.',
  bloomTest00100: 'The video monitoring is open. Please turn on the camera.',
  bloomTest00101: 'Enter the full-screen writing',
  bloomTest00102: 'Please enter the title',
  bloomTest00103: 'Please enter the content',
  bloomTest00104: 'Submitted successfully',
  bloomTest00105: 'Please enter writing through normal process',
  bloomTest00106: 'Time is up. Your essay has been submitted successfully!',
  bloomTest00107: 'Please turn on the camera',
  bloomTest00108: 'save',
  bloomTest00109: 'Automatically saved.  Last save time:',
  bloomTest00110: 'Automatically saved. ',
  bloomTest00111: 'Change Prompt',
  bloomTest00112: 'Essay questions',
  bloomTest00113: 'You are not allowed to take the exam！',
  bloomTest00114: 'Sorry, the exam has been terminated！',
  bloomTest00115: 'Remind',
  bloomTest00116: 'I Got It!',
  bloomTest00117: 'The network connection timed out, please refresh your page and wait for one minute.',
  bloomTest00118: 'The camera is occupied by other softwares, please close other web pages or softwares that use the camera.',
  bloomTest00119: 'Please turn on camera authorization for Bloom page.',
  bloomTest00120: 'Unable to find your camera, please confirm that the camera is connected or the camera driver is in good condition',
  bloomTest00121: 'Your current browser does not support the camera service, please use the latest version of Chrome browser.',
  bloomTest00122: 'The network connection fails, please check your network.',
  bloomTest00123: 'Your current browser does not support the camera service, please use the latest version of Chrome browser.',
  bloomTest00124: 'Please turn on the microphone again！',
  bloomTest00125: 'Unable to find your camera or microphone, please confirm that all devices are connected or the device drivers are in good condition.',
  bloomTest001251: 'Unable to find your camera, please confirm that the camera is connected or the camera driver is in good condition.',
  bloomTest001252: 'Unable to find your microphone, please confirm that the microphone is connected or the microphone driver is in good condition.',
  bloomTest00126: 'Please turn on the camera or microphone again',
  bloomTest00127: '',
  bloomTest00128: 'Please share your computer screen in order to start the test.',
  bloomTest00129: '',
  bloomTest00130: 'Share screen,start',
  bloomTest00131: 'Notice',
  bloomTest00132: 'Please share the whole screen.',
  bloomTest00133: 'OK',
  bloomTest00134: 'Your cell phone signal is not detected, please close all irrelevant running applications, revisit the proctoring website or scan the code again to reconnect.',
  bloomTest00135: 'You stopped the computer screen sharing, please reconnect.',
  bloomTest00136: 'Your camera is activating, please try again in 3 seconds.',
  bloomTest00137: 'Your camera and microphone are activating, please try again in 3 seconds.',
  bloomTest00138: 'The camera and mic of your computer are malfunctioned, please replace your computer. ',
  bloomTest00139: 'please enter',
  bloomTest00140: 'Select one of the prompts for you essay.(total:',
  bloomTest00141: '',
  bloomTest00142: ')',
  bloomTest00143: 'save',
  bloomTest00144: 'Failed to save, please try again',
  bloomTest00145: 'Change Prompt',
  bloomTest00146: 'Last save time : ',
  bloomTest00147: 'Words：',
  bloomTest00148: 'Writing',
  bloomTest00149: 'We need access to your computer camera for invigilation, please open the camera permission and refresh the page.',
  bloomTest00150: 'We need access to your camera and microphone for invigilation, please open the camera and microphone permission and refresh the page.',
  bloomTest00151: newChrome ? 'https://img.webloom.cn/img/testImgShui2.jpg' : 'https://img.webloom.cn/img/SE.png',
  bloomTest00152: newChrome ? 'https://img.webloom.cn/img/testImgShui2.jpg' : 'https://img.webloom.cn/img/SAME.png',
  bloomTest00153: 'https://img.webloom.cn/img/MSE.png',
  bloomTest00154: 'https://img.webloom.cn/img/weixinScanEN1.png',
  bloomTest00155: 'Tablet is not supported, please open WeChat or QQ to scan the QR code to connect to the camera of your mobile phone.',
  bloomTest00156: 'Make sure your face is visible',
  bloomTest00157: 'choose camera:',
  bloomTest00180: 'View',
  bloomTest00181: 'You do not have access to the page',
  bloomTest00182: 'Submit successfully',
  bloomTest00183: 'Submit failure',
  bloomTest00184: 'Marked',
  bloomTest00185: 'Unmark',
  bloomTest00186: '',
  bloomTest00187: 'participants have been suspected of violations, please follow the testing rules strictly.',
  bloomTest00189: 'We need access to your microphone for invigilation, please open the microphone permission and refresh the page.',
  bloomTest00188: 'The test has closed.',
  bloomTest00190: 'The network is abnormal, cannot play audio, please try again.',
  bloomTest00191: 'The browser does not support playing audio, please try again, if repeated attempts are still unsuccessful, please update the browser.',
  bloomTest00192: 'Replay audio',
  bloomTest00193: 'exceptionDescEn',
  bloomTest00194: 'The network connection times out. Refresh the device debugging task page and try again.',
  bloomTest00195: 'Refresh page',
  bloomTest00196: 'Absent',
  bloomTest00197: 'Done',
  bloomTest00198: 'Preparing',
  bloomTest00199: 'Unstarted',
  bloomTest00200: 'Testing',
  bloomTest00201: 'Time limit: ',
  bloomTest00202: ' has been answered, and you are about to answer ',
  bloomTest00203: ` has been answered, and now it's time for `,
  bloomTest00204: 'Papers can only be submitted after the examination time is over.',
  bloomTest00205: 'Countdown：',
  bloomTest00206: 'Mark',
  bloomTest00207: 'The exam has now ended. Please take a five-minute break and do not use any other electronic devices. After the break, a two-minute environment check will be conducted. Kindly return promptly before it starts.',
  bloomTest00208: 'You can start answering the questions after the countdown ends.',
  bloomTest00209: 'Calculator',
  bloomTest00210: 'Overflow',
  bloomTest00211: 'Division by 0',
  bloomTest00212: 'Error',
  bloomTest00213: 'You have finished all the process, please wait for the test to begin',
  bloomTest00214: `The test hasn't started yet.`,
  bloomTest00215: 'AI grading',
  bloomTest00216: 'AI is currently grading…',
  bloomTest00217: 'AI grading results',
  bloomTest00218: 'Please write at least 200 words for the AI to analyze it for you.',
  bloomTest00219: 'The content is generated by AI and is for reference only. There is no academic commitment.',
  bloomTest00220: 'The number of AI grading attempts has reached the limit.',
  bloomTest00221: 'The AI grading has encountered a problem. Please try again later.',
  bloomTest00222: 'There are incorrect expressions in the writing. Please correct them before conducting the AI grading.'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/bloom-test/index.js